/**
 * Calculate statistics from courses data
 * @param {Array} courses - Array of course objects
 * @returns {Object} Statistics object
 */
export const calculateStats = (courses) => {
  const stats = {
    total: 0,
    hls: 0,
    mp4: 0,
    converting: 0,
  };

  courses.forEach((course) => {
    stats.total += course.total_videos || 0;
    stats.hls += course.hls_count || 0;
    stats.mp4 += course.mp4_count || 0;
    stats.converting += course.converting_count || 0;
  });

  // Calculate percentages
  stats.hlsPercentage = stats.total > 0 
    ? ((stats.hls / stats.total) * 100).toFixed(1) 
    : 0;
    
  stats.mp4Percentage = stats.total > 0 
    ? ((stats.mp4 / stats.total) * 100).toFixed(1) 
    : 0;
    
  stats.convertingPercentage = stats.total > 0 
    ? ((stats.converting / stats.total) * 100).toFixed(1) 
    : 0;

  return stats;
};

/**
 * Format bytes to human readable format
 * @param {number} bytes 
 * @returns {string}
 */
export const formatBytes = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + " " + sizes[i];
};

/**
 * Estimate conversion cost per video
 * @param {number} durationMinutes - Video duration in minutes
 * @returns {number} Estimated cost in USD
 */
export const estimateCost = (durationMinutes = 60) => {
  // Cost per minute for 3 qualities (480p, 720p, 1080p)
  const costPer480p = 0.0075;
  const costPer720p = 0.015;
  const costPer1080p = 0.03;
  
  const totalCostPerMinute = costPer480p + costPer720p + costPer1080p;
  
  return (durationMinutes * totalCostPerMinute).toFixed(2);
};